import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';
import SelectBox from '../components/SelectBox';
import Button from '../audi-ui-components/Button';
import { Formik, Form } from 'formik';
import Spinner from '../audi-ui-components/Spinner';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import cookie from '../lib/cookie';

const mapStateToProps = (state) => {
    return {
        cart: state.shoppingCart.cart,
        disableNav: state.shoppingCart.disableNav,
    };
};

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        fetchData: ACTIONS_CREATOR.fetchData,
        setShoppingCart: ACTIONS_CREATOR.setShoppingCart,
        disableNavItems: ACTIONS_CREATOR.disableNavItems,
        setAlertMessage: ACTIONS_CREATOR.setAlertMessage,
        setHero: ACTIONS_CREATOR.setHero
    },
    dispatch,
);

class LocationPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: true,
            programs: [],
            availableExperiences: [],
            selectedVenueId: null,
            selectedProgramId: null,
            selectedExperienceId: null,
            locationDetails: null,
        };
    }

    componentDidMount() {
        this.fetchLocations();
    }

    componentWillUnmount() {
        this.props.setHero();
    }

    fetchLocations = () => {
        this.setState({fetching: true});
        this.props.setAlertMessage(true, 'success', 'Fetching circuit details...');
        this.props.fetchData(`/1/venues?$filter=slug eq '${this.props.locationSlug}'`, 'GET')
        .then(data => {
          if (data && data[0] && data[0].id) {
            this.setState({selectedVenueId: data[0].id, locationDetails: data[0]});
            this.props.setHero("", data[0].heroImage, data[0].mobileHeroImage);
            this.fetchPrograms(data[0].id);
          } else {
            this.props.setAlertMessage(true, 'danger', "Could not find the selected circuit");
          }
        })
        .catch(err => {
            console.log(err);
            err.then(errorMessage => {
                this.props.setAlertMessage(true, 'danger', errorMessage.message);
            });
            this.setState({fetching: false});
        });
    }

    fetchPrograms = (locationId) => {
        const {programSlug} = this.props;
        this.props.fetchData(`/1/venues/${locationId}/programs?$filter=isPrivate eq false`)
        .then(data => {
            if (data || data.length > 0) {
              let filteredData = [];
              let myProg = data[0] || {};
              for (let i=0; i<data.length; i++) {
                let prog = data[i];
                let exp = _filter(prog.experiences, {isPrivate: false});
                if (exp && exp.length > 0) {
                  filteredData.push(prog);
                  if (programSlug && prog.slug === programSlug) {
                    myProg = prog;
                  }
                }
              }
              this.setState({programs: filteredData, selectedProgramId: myProg.id, fetching: false});
              this.setExperiences(myProg.id, filteredData);
            }
            this.props.setAlertMessage(false);
        }).catch(err => {
            console.log(err);
            err.then(errorMessage => {
                this.props.setAlertMessage(true, 'danger', errorMessage.message);
            });
            this.setState({fetching: false});
        });
    }

    setExperiences = (programId, programs) => {
        var _programs = programs || this.state.programs;
        let list = [];
        for (let i=0; i<_programs.length; i++) {
            if (_programs[i].id.toString() === programId.toString()) {
                list = _filter(_programs[i].experiences, {isPrivate: false});
                break;
            }
        }
        let id = list.length ? list[0].id : null;
        this.setState({availableExperiences: list, selectedExperienceId: id, selectedProgramId: programId});
    }

    get currentExperience() {
        const {availableExperiences, selectedExperienceId} = this.state;
        const experience = this.state.availableExperiences ? _find(availableExperiences, function(o) { return o.id.toString() === selectedExperienceId.toString(); }) : null;
        return experience;
    }

    addItemToCart = (experience) => {
        this.props.setAlertMessage(true, 'success', 'Adding to cart...');
        const {programs, selectedProgramId} = this.state;
        const currentProgram = programs ? _find(programs, function(o) { return o.id.toString() === selectedProgramId.toString(); }): {};
        const url = `/1/cart/${this.props.cart.id}/item`;
        const body = {
            type: CONST.ITEM_EXPERIENCE,
            programId: this.state.selectedProgramId,
            experienceId: experience.id,
            amount: currentProgram.cost,
        };
        this.props.fetchData(url, 'POST', body)
            .then(result => {
                this.props.setShoppingCart(result);
                cookie.setItem("cartId", `${result.id}`, null, '/');
                this.props.setAlertMessage(false);
            })
            .catch(err => {
                err.then( errorMessage => {
                    this.props.setAlertMessage(true, 'danger', errorMessage.message);
                });
            });
    }

    render() {
        const {programs, availableExperiences, locationDetails, selectedProgramId, fetching} = this.state;
        const currentProgram = programs ? _find(programs, function(o) { return o.id.toString() === selectedProgramId.toString(); }): {};
        var spotsLeft = false;
        let exp = this.currentExperience;
        if (exp && exp !== null) {
            spotsLeft = exp.totalSeats - exp.bookedSeats;
        }
        return (
            <section className="product-page mb-5">
                {locationDetails && <div className="mb-5">
                    <p className="aui-headline-5">Circuit details</p>
                    {locationDetails.address && <p>{locationDetails.address}</p>}
                    {locationDetails.description && <div dangerouslySetInnerHTML={{__html: locationDetails.description}}></div>}
                </div>}

                {!fetching && programs.length === 0 && <div className="mb-5 aui-color-text-red">
                    Sorry. There are currently no experiences available at this circuit. Please check back later. <a href={CONST.NEMO_URL_PRODUCTION} className="aui-textlink">Return to Audi driving experience</a>.
                </div>}

                {programs && programs.length > 0 && <Formik
                    enableReinitialize
                    initialValues={{
                        course: this.state.selectedProgramId || "",
                        dateTime: this.state.selectedExperienceId || "",
                    }}
                    onSubmit={(values, actions) => { this.addItemToCart(this.currentExperience); }}
                    render= {({values, handleChange}) => (
                        <Form id="experienceForm">
                            <div className="row">
                                <div className="col">
                                    <div className="row mb-4">
                                        <div className="col-auto">
                                            <div className="product-label aui-headline-5">Experience</div>
                                        </div>
                                        <div className="col">
                                            <SelectBox name="course"
                                                value={values.course}
                                                onChange= {(v, e) => { handleChange(e); this.setExperiences(v);}}
                                                options={programs ? programs.map((item) => { return {value: item.id, label: item.name}; }) : []}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-auto">
                                            <div className="product-label aui-headline-5">Date + Time</div>
                                        </div>
                                        <div className="col">
                                            <SelectBox name="dateTime"
                                                value={values.dateTime}
                                                disabled = {this.state.fetching}
                                                onChange= {(v, e) => { handleChange(e); this.setState({selectedExperienceId: v}); }}
                                                options={availableExperiences ? availableExperiences.map(experience => {
                                                        const dateOptions = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
                                                        const startDate = new Date(experience.startDate);
                                                        const dateFormat = new Intl.DateTimeFormat('en-GB', dateOptions);
                                                        return {
                                                            label: `${ dateFormat.format(startDate) }, ${experience.startTime} - ${experience.endTime}`,
                                                            value: experience.id,
                                                        };
                                                    }) : []}
                                            />
                                        </div>
                                    </div>

                                    {this.state.fetching &&  <div className="spots-left"><Spinner isContinuous small /></div>}
                                    {!this.state.fetching && <div className="spots-left">
                                        {spotsLeft > 5 && <strong>Limited spots available</strong>}
                                        {spotsLeft < 5 && spotsLeft > 0 && <strong>{spotsLeft} Spots left</strong>}
                                        {spotsLeft === 0 && <strong className="aui-color-text-red">0 Spots left</strong>}
                                    </div>}

                                </div>
                                <div className="col-auto d-none d-medium-block"><div className="product-page--divider"></div></div>
                                <div className="col-12 col-medium-4 total-cost">
                                    <div className="row">
                                        <div className="col-auto col-medium-12">
                                            <div className="aui-headline-5 py-2 pt-medium-0 px-2">TOTAL COST</div>
                                        </div>
                                        <div className="col-auto col-medium-12">
                                            <div className="aui-headline-5 grey-background py-2 px-3 mb-3">AUD$ <span style={{fontWeight: 'normal'}}>{currentProgram && currentProgram.cost}</span></div>
                                        </div>
                                    </div>
                                    <div style={{textAlign: 'right'}}><Button variant="primary" className="ms-auto" type="submit" disabled={!spotsLeft || spotsLeft === 0}>Add to cart</Button></div>
                                </div>
                           </div>
                        </Form>
                    )}
                />}
            </section>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationPage);
